import React, { useContext } from "react";
import { Typography } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { FormContext } from "../../util/context";
import LinkMui from "@material-ui/core/Link";
import { Link } from "../../util/router";

const Intro = () => {
  const [form, setForm] = useContext(FormContext);
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <Grid item={true}>
        <Container maxWidth="sm">
          <Typography variant="body1">
            If you are interested in a trial of our services to give you deeper
            insights into your neuromechanics, we encourage you to fill out the
            following form so we can prepare to serve you.
          </Typography>
          <Typography variant="body1">
            This should take around <b> 5 minutes </b> and at the end you will
            be able to book your free assessment with one of our specialists.
          </Typography>
          <Typography variant="body1">
            By filling out this form you are agreeing to our{" "}
            <LinkMui component={Link} to="/legal/privacy-policy">
              <strong>privacy policy</strong>
            </LinkMui>
            {" and "}
            <LinkMui component={Link} to="/legal/terms-of-service">
              <strong>terms of service</strong>
            </LinkMui>
          </Typography>
        </Container>
      </Grid>
      <Grid item={true} xs={12}>
        <Box>
          <Button
            variant="contained"
            fullWidth
            color="primary"
            onClick={() => setForm({ ...form, count: form.count + 1 })}
          >
            Start
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Intro;
